/**
 * Customer visits keyed by person and day, so the attendance register can show
 * each row's visits without a request per row.
 */
export const visitKey = (userId, date) => `${userId}|${String(date || '').slice(0, 10)}`;

export function groupVisits(visits) {
  const groups = new Map();
  for (const v of Array.isArray(visits) ? visits : []) {
    const key = visitKey(v?.user_id, v?.date);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(v);
  }
  // Earliest first within a day: the order the person made them.
  for (const list of groups.values()) {
    list.sort((a, b) => new Date(a.started_at) - new Date(b.started_at));
  }
  return groups;
}

export const OUTCOME_LABELS = {
  INTERESTED: 'Interested',
  FOLLOW_UP: 'Follow-up',
  NOT_INTERESTED: 'Not interested',
  DONE: 'Done'
};

export const mapUrl = (lat, lng) =>
  lat != null && lng != null ? `https://maps.google.com/?q=${lat},${lng}` : null;
